import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "font-semibold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[0] || (_cache[0] = () => _ctx.handleReply()),
    class: "flex flex-col w-full text-left cursor-pointer"
  }, [
    _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.getUserName), 1),
    _createElementVNode("span", null, _toDisplayString(_ctx.state.content.message || _ctx.state.content.content), 1)
  ]))
}